import { render } from "./PriceComparison.vue?vue&type=template&id=8a7223c6"
import script from "./PriceComparison.vue?vue&type=script&lang=js"
export * from "./PriceComparison.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__